import * as types from "./types";

const INITIAL_STATE = {
  list: [],
  meta: {},
  addedAdmin: null
};

const adminsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_ADMINS_RESPONSE:
      return {
        ...state,
        list: action.payload.list,
        meta: action.payload.meta
      };
    case types.ADD_ADMIN_RESPONSE:
      return { ...state, addedAdmin: action.payload };
    default:
      return state;
  }
};

export default adminsReducer;
